/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/* @flow strict-local */

import type { Realm } from "../../realm.js";
import type { NativeFunctionValue } from "../../values/index.js";
import { build } from "./Error.js";

export default function(realm: Realm): NativeFunctionValue {
  return build("SyntaxError", realm);
}
